module.exports = __webpack_public_path__ + "resources/img/img_cubrid_01.814287460893b2481ea102c8c65861f7.png";